class InfiniteScroll extends HTMLElement {
    constructor() {
      super();
      this.currentPage = 1;
      this.isLoading = false;
      this.hasMorePages = true;
      this.observer = null;
      this.sentinel = null;
      this.productGrid = null;
      this.collectionUrl = window.location.pathname;
      this.sectionId = null;
      
      this.init();
    }
  
    init() {
      // Esperar a que el DOM esté listo
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.setup());
      } else {
        this.setup();
      }
    }
  
    setup() {
      this.productGrid = document.getElementById('product-grid');
      if (!this.productGrid) {
        console.log('InfiniteScroll: No se encontró product-grid');
        return;
      }
  
      this.sectionId = this.productGrid.dataset.id;
      if (!this.sectionId) {
        console.log('InfiniteScroll: No se encontró section ID');
        return;
      }
  
      // Obtener productos por página
      this.productsPerPage = parseInt(this.productGrid.dataset.productsPerPage) || 12;
      console.log('InfiniteScroll: productsPerPage configurado:', this.productsPerPage);
  
      // Obtener la página actual de la URL
      const urlParams = new URLSearchParams(window.location.search);
      this.currentPage = parseInt(urlParams.get('page')) || 1;
  
      // Contar productos actuales
      const currentProducts = this.productGrid.querySelectorAll('li.grid__item').length;
      console.log('InfiniteScroll: Productos actuales en página', this.currentPage, ':', currentProducts);
  
      // Verificar si hay más páginas - SIMPLIFICADO: Si hay paginación visible, asumir que hay más
      const pagination = document.querySelector('.pagination-wrapper');
      
      if (pagination) {
        // Si hay paginación, siempre asumir que hay más páginas (excepto si estamos en la última)
        // Buscar números de página visibles
        const allPageItems = pagination.querySelectorAll('.pagination__item');
        const pageNumbers = Array.from(allPageItems).map(el => {
          const text = el.textContent.trim();
          const num = parseInt(text);
          return isNaN(num) ? null : num;
        }).filter(n => n !== null);
        
        if (pageNumbers.length > 0) {
          const maxVisiblePage = Math.max(...pageNumbers);
          const currentPageItem = pagination.querySelector('.pagination__item--current');
          const currentPageNum = currentPageItem ? parseInt(currentPageItem.textContent) || this.currentPage : this.currentPage;
          
          // Si hay más de una página visible o estamos en una página menor que la máxima visible
          if (pageNumbers.length > 1 || currentPageNum < maxVisiblePage) {
            this.hasMorePages = true;
            console.log('InfiniteScroll: Paginación detectada - Página actual:', currentPageNum, 'Máxima visible:', maxVisiblePage, '-> hasMorePages: true');
          } else {
            // Verificar botón siguiente como respaldo
            const lastLi = pagination.querySelector('li:last-child');
            if (lastLi) {
              const nextLink = lastLi.querySelector('a');
              this.hasMorePages = !!nextLink;
              console.log('InfiniteScroll: Verificando botón siguiente -> hasMorePages:', this.hasMorePages);
            }
          }
        } else {
          // Si hay paginación pero no encontramos números, verificar botón siguiente
          const nextButton = pagination.querySelector('a[aria-label*="next"], a[aria-label*="siguiente"], li:last-child a');
          this.hasMorePages = !!nextButton;
          console.log('InfiniteScroll: Paginación sin números detectados, verificando botón -> hasMorePages:', this.hasMorePages);
        }
        
        // FALLBACK: Si hay paginación y productos suficientes, siempre activar
        if (!this.hasMorePages && currentProducts >= this.productsPerPage) {
          console.log('InfiniteScroll: FALLBACK - Hay paginación y', currentProducts, 'productos (>=', this.productsPerPage, '). Activando scroll infinito.');
          this.hasMorePages = true;
        }
      } else {
        // Si no hay paginación, verificar por cantidad de productos
        this.hasMorePages = currentProducts >= this.productsPerPage;
        console.log('InfiniteScroll: Sin paginación, verificando por productos -> hasMorePages:', this.hasMorePages);
      }
      
      console.log('InfiniteScroll: Estado final - hasMorePages:', this.hasMorePages, 'currentPage:', this.currentPage, 'currentProducts:', currentProducts);
  
      // SIEMPRE crear el sentinel y el observer, incluso si hasMorePages es false
      // porque puede cambiar después de cargar la primera página
      this.createSentinel();
      
      if (!this.sentinel) {
        console.error('InfiniteScroll: ERROR - No se pudo crear el sentinel');
        return;
      }
      
      // Configurar Intersection Observer
      this.setupObserver();
  
      // Reiniciar cuando cambien los filtros
      this.setupFilterListener();
      
      // Agregar listener de scroll manual como fallback
      this.setupScrollListener();
      
      console.log('InfiniteScroll: Inicializado correctamente. Sentinel:', !!this.sentinel, 'Observer:', !!this.observer);
    }
    
    setupScrollListener() {
      // Remover listener anterior si existe
      if (this.scrollHandler) {
        window.removeEventListener('scroll', this.scrollHandler);
      }
      
      // Crear handler de scroll
      this.scrollHandler = () => {
        if (this.isLoading || !this.hasMorePages) return;
        
        if (!this.sentinel) return;
        
        const rect = this.sentinel.getBoundingClientRect();
        const windowHeight = window.innerHeight || document.documentElement.clientHeight;
        
        // Si el sentinel está a menos de 600px del viewport, cargar
        if (rect.top <= windowHeight + 600) {
          console.log('InfiniteScroll: Scroll detectado - Sentinel a', Math.round(rect.top - windowHeight), 'px del viewport');
          this.loadNextPage();
        }
      };
      
      // Throttle del scroll para mejor rendimiento
      let scrollTimeout;
      const throttledScrollHandler = () => {
        if (scrollTimeout) return;
        scrollTimeout = setTimeout(() => {
          this.scrollHandler();
          scrollTimeout = null;
        }, 100);
      };
      
      window.addEventListener('scroll', throttledScrollHandler, { passive: true });
      console.log('InfiniteScroll: Scroll listener configurado como fallback');
    }
  
    createSentinel() {
      // Eliminar sentinel anterior si existe
      const existingSentinel = document.querySelector('.infinite-scroll-sentinel');
      if (existingSentinel) {
        existingSentinel.remove();
      }
  
      // Crear nuevo sentinel
      this.sentinel = document.createElement('div');
      this.sentinel.className = 'infinite-scroll-sentinel';
      this.sentinel.style.height = '1px';
      this.sentinel.style.width = '100%';
      this.sentinel.style.marginTop = '3rem';
      this.sentinel.style.marginBottom = '3rem';
      this.sentinel.style.visibility = 'visible'; // Cambiar a visible para debugging
      this.sentinel.style.opacity = '0.1'; // Muy transparente pero visible
      this.sentinel.style.backgroundColor = 'red'; // Temporal para verificar posición
      this.sentinel.setAttribute('data-sentinel', 'true');
      
      // Insertar después del grid, dentro del contenedor collection
      const container = this.productGrid.closest('.collection');
      if (container) {
        // Insertar después del ul del grid, antes de la paginación si existe
        const pagination = container.querySelector('.pagination-wrapper');
        if (pagination) {
          container.insertBefore(this.sentinel, pagination);
        } else {
          // Si no hay paginación, insertar después del grid
          if (this.productGrid.nextSibling) {
            container.insertBefore(this.sentinel, this.productGrid.nextSibling);
          } else {
            container.appendChild(this.sentinel);
          }
        }
        console.log('InfiniteScroll: Sentinel creado dentro de .collection, después del grid');
      } else {
        // Si no hay contenedor, insertar después del grid directamente
        if (this.productGrid.parentNode) {
          this.productGrid.parentNode.insertBefore(this.sentinel, this.productGrid.nextSibling);
          console.log('InfiniteScroll: Sentinel creado después del grid (sin contenedor .collection)');
        } else {
          console.error('InfiniteScroll: ERROR - No se pudo encontrar contenedor para el sentinel');
          return;
        }
      }
      
      // Verificar que el sentinel esté en el DOM
      if (document.contains(this.sentinel)) {
        const rect = this.sentinel.getBoundingClientRect();
        console.log('InfiniteScroll: Sentinel creado y en DOM. Posición:', {
          top: rect.top,
          left: rect.left,
          width: rect.width,
          height: rect.height,
          visible: rect.height > 0 && rect.width > 0
        });
      } else {
        console.error('InfiniteScroll: ERROR - Sentinel no está en el DOM');
      }
    }
  
    setupObserver() {
      // Destruir observer anterior si existe
      if (this.observer) {
        this.observer.disconnect();
      }
  
      const options = {
        root: null,
        rootMargin: '500px', // Cargar cuando esté a 500px del final (muy agresivo)
        threshold: 0.01
      };
  
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          console.log('InfiniteScroll: Observer callback - isIntersecting:', entry.isIntersecting, 'intersectionRatio:', entry.intersectionRatio);
          if (entry.isIntersecting) {
            console.log('InfiniteScroll: Sentinel detectado! hasMorePages:', this.hasMorePages, 'isLoading:', this.isLoading);
            if (!this.isLoading) {
              // Intentar cargar incluso si hasMorePages es false (puede cambiar)
              this.loadNextPage();
            } else {
              console.log('InfiniteScroll: Ya se está cargando, ignorando trigger');
            }
          }
        });
      }, options);
  
      if (this.sentinel) {
        this.observer.observe(this.sentinel);
        console.log('InfiniteScroll: Observer configurado en sentinel. rootMargin: 500px');
        
        // Verificar inmediatamente si el sentinel es visible
        setTimeout(() => {
          const rect = this.sentinel.getBoundingClientRect();
          const isVisible = rect.top < window.innerHeight + 500; // 500px es el rootMargin
          console.log('InfiniteScroll: Verificación inicial - Sentinel visible:', isVisible, 'top:', rect.top, 'window height:', window.innerHeight);
        }, 100);
      } else {
        console.error('InfiniteScroll: ERROR - No hay sentinel para observar');
      }
    }
  
    setupFilterListener() {
      // Escuchar cambios en el ProductGridContainer cuando se actualizan los filtros
      const productGridContainer = document.getElementById('ProductGridContainer');
      if (productGridContainer) {
        const observer = new MutationObserver((mutations) => {
          // Verificar si el grid fue reemplazado completamente (filtros)
          mutations.forEach(mutation => {
            if (mutation.type === 'childList') {
              const newGrid = document.getElementById('product-grid');
              if (newGrid && newGrid !== this.productGrid) {
                // El grid fue reemplazado, reiniciar
                this.productGrid = newGrid;
                this.reset();
              }
            }
          });
        });
        
        observer.observe(productGridContainer, {
          childList: true,
          subtree: true
        });
      }
  
      // También escuchar eventos personalizados si facets.js los emite
      document.addEventListener('facetFiltersUpdated', () => {
        this.reset();
      });
    }
  
    reset() {
      this.currentPage = 1;
      this.isLoading = false;
      
      // Actualizar referencia al grid
      this.productGrid = document.getElementById('product-grid');
      if (this.productGrid) {
        this.productsPerPage = parseInt(this.productGrid.dataset.productsPerPage) || 12;
      }
      
      // Verificar si hay más páginas después del reset
      const pagination = document.querySelector('.pagination-wrapper');
      let hasMorePagesFromPagination = false;
      
      if (pagination) {
        const lastLi = pagination.querySelector('li:last-child');
        if (lastLi) {
          // Si el último li tiene un <a> (no un <span>), significa que hay siguiente página
          const nextLink = lastLi.querySelector('a');
          const disabledSpan = lastLi.querySelector('span.disabled');
          hasMorePagesFromPagination = !!nextLink && !disabledSpan;
          
          // También verificar por aria-label
          if (nextLink) {
            const ariaLabel = nextLink.getAttribute('aria-label') || '';
            if (ariaLabel.toLowerCase().includes('next') || ariaLabel.toLowerCase().includes('siguiente')) {
              hasMorePagesFromPagination = true;
            }
          }
        }
        
        // Si no encontramos en el último li, buscar cualquier botón siguiente
        if (!hasMorePagesFromPagination) {
          const nextButton = pagination.querySelector('a[aria-label*="next"], a[aria-label*="siguiente"]');
          hasMorePagesFromPagination = !!nextButton;
        }
      }
      
      // También verificar por cantidad de productos
      if (this.productGrid) {
        const currentProducts = this.productGrid.querySelectorAll('li.grid__item').length;
        const hasMorePagesFromProducts = currentProducts >= this.productsPerPage;
        
        // Usar la lógica de paginación si está disponible, sino usar la lógica de productos
        this.hasMorePages = pagination ? hasMorePagesFromPagination : hasMorePagesFromProducts;
      } else {
        this.hasMorePages = hasMorePagesFromPagination;
      }
      
      // Recrear sentinel
      if (this.sentinel && this.observer) {
        this.observer.unobserve(this.sentinel);
      }
      
      setTimeout(() => {
        this.productGrid = document.getElementById('product-grid');
        if (this.productGrid) {
          this.createSentinel();
          if (this.sentinel && this.observer) {
            this.observer.observe(this.sentinel);
          }
        }
      }, 100);
    }
  
    async loadNextPage() {
      if (this.isLoading) {
        console.log('InfiniteScroll: Ya se está cargando una página');
        return;
      }
      
      // SIEMPRE intentar cargar si hay paginación visible, sin importar hasMorePages
      const pagination = document.querySelector('.pagination-wrapper');
      const currentProducts = this.productGrid.querySelectorAll('li.grid__item').length;
      
      // Si hay paginación visible, siempre intentar cargar
      if (pagination) {
        console.log('InfiniteScroll: Hay paginación visible, intentando cargar siguiente página...');
        this.hasMorePages = true; // Forzar a true si hay paginación
      } else if (!this.hasMorePages) {
        // Si no hay paginación y hasMorePages es false, verificar por productos
        if (currentProducts >= this.productsPerPage) {
          console.log('InfiniteScroll: Sin paginación pero hay', currentProducts, 'productos (>=', this.productsPerPage, '), intentando cargar...');
          this.hasMorePages = true;
        } else {
          console.log('InfiniteScroll: No hay más páginas (sin paginación y menos productos)');
          return;
        }
      }
  
      this.isLoading = true;
      this.showLoadingIndicator();
      console.log('InfiniteScroll: Cargando página', this.currentPage + 1);
  
      try {
        const nextPage = this.currentPage + 1;
        const urlParams = new URLSearchParams(window.location.search);
        urlParams.set('page', nextPage);
        
        // Construir URL con parámetros de filtros y página
        const queryString = urlParams.toString();
        const fetchUrl = `${this.collectionUrl}?section_id=${this.sectionId}&${queryString}`;
  
        console.log('InfiniteScroll: Fetching:', fetchUrl);
        const response = await fetch(fetchUrl);
        if (!response.ok) {
          throw new Error(`Error HTTP: ${response.status}`);
        }
  
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        
        // Buscar el ProductGridContainer en la respuesta
        const responseContainer = doc.getElementById('ProductGridContainer');
        if (!responseContainer) {
          console.log('InfiniteScroll: No se encontró ProductGridContainer en la respuesta');
          this.hasMorePages = false;
          this.hideLoadingIndicator();
          return;
        }
  
        const newProductGrid = responseContainer.querySelector('#product-grid');
        if (!newProductGrid) {
          console.log('InfiniteScroll: No se encontró product-grid en la respuesta');
          this.hasMorePages = false;
          this.hideLoadingIndicator();
          return;
        }
  
        const newProducts = Array.from(newProductGrid.querySelectorAll('li.grid__item'));
        
        if (newProducts.length === 0) {
          console.log('InfiniteScroll: No hay productos nuevos - última página alcanzada');
          this.hasMorePages = false;
          this.hideLoadingIndicator();
          // Remover el sentinel ya que no hay más páginas
          if (this.sentinel && this.observer) {
            this.observer.unobserve(this.sentinel);
          }
          return;
        }
  
        console.log('InfiniteScroll: Agregando', newProducts.length, 'productos');
  
        // Agregar nuevos productos al grid
        newProducts.forEach(product => {
          this.productGrid.appendChild(product);
        });
  
        // Reinicializar scripts de los nuevos productos
        this.initializeProductScripts(newProducts);
  
        this.currentPage = nextPage;
        
        // Verificar si hay más páginas en la respuesta
        const newPagination = responseContainer.querySelector('.pagination-wrapper');
        if (newPagination) {
          const lastLi = newPagination.querySelector('li:last-child');
          let hasMore = false;
          
          if (lastLi) {
            // Si el último li tiene un <a> (no un <span>), significa que hay siguiente página
            const nextLink = lastLi.querySelector('a');
            const disabledSpan = lastLi.querySelector('span.disabled');
            hasMore = !!nextLink && !disabledSpan;
            
            // También verificar por aria-label
            if (nextLink) {
              const ariaLabel = nextLink.getAttribute('aria-label') || '';
              if (ariaLabel.toLowerCase().includes('next') || ariaLabel.toLowerCase().includes('siguiente')) {
                hasMore = true;
              }
            }
          }
          
          // Si no encontramos en el último li, buscar cualquier botón siguiente
          if (!hasMore) {
            const nextButton = newPagination.querySelector('a[aria-label*="next"], a[aria-label*="siguiente"]');
            hasMore = !!nextButton;
          }
          
          this.hasMorePages = hasMore;
          console.log('InfiniteScroll: Más páginas disponibles:', this.hasMorePages);
        } else {
          // Si no hay paginación, verificar si recibimos menos productos de los esperados
          if (newProducts.length < this.productsPerPage) {
            this.hasMorePages = false;
            console.log('InfiniteScroll: Última página (menos productos que productsPerPage)');
          } else {
            // Si recibimos exactamente productsPerPage, podría haber más
            this.hasMorePages = newProducts.length >= this.productsPerPage;
          }
        }
  
        // Actualizar URL sin recargar la página
        const newUrl = `${this.collectionUrl}${queryString ? '?' + queryString : ''}`;
        window.history.replaceState({}, '', newUrl);
  
      } catch (error) {
        console.error('InfiniteScroll: Error al cargar productos:', error);
        this.hasMorePages = false;
      } finally {
        this.isLoading = false;
        this.hideLoadingIndicator();
        
        // Recrear sentinel para continuar observando
        if (this.sentinel && this.observer) {
          this.observer.unobserve(this.sentinel);
        }
        this.createSentinel();
        if (this.sentinel && this.observer) {
          this.observer.observe(this.sentinel);
        }
        
        // Verificar posición del sentinel después de agregar productos
        setTimeout(() => {
          if (this.sentinel) {
            const rect = this.sentinel.getBoundingClientRect();
            const windowHeight = window.innerHeight || document.documentElement.clientHeight;
            console.log('InfiniteScroll: Sentinel después de cargar - top:', Math.round(rect.top), 'window height:', windowHeight, 'distancia:', Math.round(rect.top - windowHeight));
          }
        }, 200);
      }
    }
  
    initializeProductScripts(products) {
      // Reinicializar scripts necesarios para los nuevos productos
      if (typeof window.ProductCard !== 'undefined') {
        products.forEach(product => {
          const productCard = product.querySelector('product-card');
          if (productCard && typeof productCard.init === 'function') {
            productCard.init();
          }
        });
      }
    }
  
    showLoadingIndicator() {
      let loader = document.querySelector('.infinite-scroll-loader');
      if (!loader) {
        loader = document.createElement('div');
        loader.className = 'infinite-scroll-loader';
        loader.innerHTML = `
          <div class="infinite-scroll-loader__spinner"></div>
          <p class="infinite-scroll-loader__text">Cargando más productos...</p>
        `;
        
        const container = this.productGrid.closest('.collection');
        if (container) {
          container.appendChild(loader);
        }
      }
      loader.style.display = 'block';
    }
  
    hideLoadingIndicator() {
      const loader = document.querySelector('.infinite-scroll-loader');
      if (loader) {
        loader.style.display = 'none';
      }
    }
  }
  
  customElements.define('infinite-scroll', InfiniteScroll);
  
  // Inicializar automáticamente
  function initInfiniteScroll() {
    const productGrid = document.getElementById('product-grid');
    if (!productGrid) {
      console.log('InfiniteScroll: product-grid no encontrado, reintentando...');
      return;
    }
    
    if (document.querySelector('infinite-scroll')) {
      console.log('InfiniteScroll: Ya existe una instancia');
      return;
    }
    
    console.log('InfiniteScroll: Inicializando...');
    const infiniteScroll = document.createElement('infinite-scroll');
    document.body.appendChild(infiniteScroll);
  }
  
  // Inicializar cuando el DOM esté listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(initInfiniteScroll, 500); // Dar tiempo a que se carguen otros scripts
    });
  } else {
    setTimeout(initInfiniteScroll, 500);
  }
  
  // Reinicializar después de que facets.js actualice el contenido
  function setupFacetsIntegration() {
    if (typeof FacetFiltersForm !== 'undefined') {
      const originalRenderProductGridContainer = FacetFiltersForm.renderProductGridContainer;
      if (originalRenderProductGridContainer) {
        FacetFiltersForm.renderProductGridContainer = function(html) {
          originalRenderProductGridContainer.call(this, html);
          // Esperar un momento para que el DOM se actualice
          setTimeout(() => {
            const existingScroll = document.querySelector('infinite-scroll');
            if (existingScroll) {
              existingScroll.reset();
            } else {
              initInfiniteScroll();
            }
          }, 200);
        };
        console.log('InfiniteScroll: Integración con facets.js configurada');
      }
    } else {
      // Reintentar después de un momento si facets.js aún no está cargado
      setTimeout(setupFacetsIntegration, 100);
    }
  }
  
  // Intentar configurar la integración cuando facets.js esté disponible
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupFacetsIntegration);
  } else {
    setupFacetsIntegration();
  }
  
  